/* eslint-disable */
import * as Types from './types';

import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { fetcher } from '../../fetcher';
export type CartSettingsQueryVariables = Types.Exact<{
  handle?: Types.InputMaybe<Types.Scalars['String']>;
  locale?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type CartSettingsQuery = { __typename?: 'Query', cartSettingsCollection?: { __typename?: 'CartSettingsCollection', items: Array<{ __typename?: 'CartSettings', title?: string | null, showCartMessage?: boolean | null, cartMessage?: string | null, freeShippingAmount?: number | null, isFreeShippingActive?: boolean | null, showCartDiscountCodeBox?: boolean | null, seoTitle?: string | null, seoDescription?: string | null } | null> } | null };

export declare const cartSettings: import("graphql").DocumentNode;

export const CartSettingsDocument = /*#__PURE__*/ `
    query cartSettings($handle: String = "cart-settings", $locale: String = "en-US") {
  cartSettingsCollection(
    where: {handle: $handle, sys: {id_exists: true}}
    locale: $locale
  ) {
    items {
      title
      showCartMessage
      cartMessage
      freeShippingAmount
      isFreeShippingActive
      showCartDiscountCodeBox
      seoTitle
      seoDescription
    }
  }
}
    `;
export const useCartSettingsQuery = <
      TData = CartSettingsQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables?: CartSettingsQueryVariables,
      options?: UseQueryOptions<CartSettingsQuery, TError, TData>
    ) =>
    useQuery<CartSettingsQuery, TError, TData>(
      variables === undefined ? ['cartSettings'] : ['cartSettings', variables],
      fetcher<CartSettingsQuery, CartSettingsQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, CartSettingsDocument, variables, options),
      options
    );

useCartSettingsQuery.getKey = (variables?: CartSettingsQueryVariables) => variables === undefined ? ['cartSettings'] : ['cartSettings', variables];
;

useCartSettingsQuery.fetcher = (dataSource: { endpoint: string, fetchParams?: RequestInit }, variables?: CartSettingsQueryVariables, options?: RequestInit['headers']) => fetcher<CartSettingsQuery, CartSettingsQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, CartSettingsDocument, variables, options);